import { useState, type FormEvent } from "react";
import { requireSupabase } from "../lib/supabase";
import { starfallAuthUrl } from "../lib/config";

export function CloudLogin() {
  const db = requireSupabase();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function signIn(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");

    const result = await db.auth.signInWithPassword({ email, password });

    setBusy(false);

    if (result.error) {
      setError(result.error.message);
    }
  }

  return (
    <main className="cloud-gate">
      <section className="cloud-card">
        <div className="brand-mark cloud-mark">✦</div>
        <div className="eyebrow">STARFALL WORKS / WORLDWARDEN</div>
        <h1>Enter Worldwarden</h1>
        <p>Sign in with your Starfall Works account.</p>

        <form className="cloud-form" onSubmit={signIn}>
          <label>
            Email address
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </label>

          <label>
            Password
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>

          {error && <div className="error-box">{error}</div>}

          <button className="primary" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <a className="cloud-link" href={`${starfallAuthUrl}/login`}>
          Manage your Starfall Works account
        </a>
      </section>
    </main>
  );
}
